const FieldLabel = ({ label, name, required }) => {
  return (
    <label htmlFor={name} className="label">
      {label}
      {required && <span className="required"> *</span>}
    </label>
  )
}

export default FieldLabel
